<template>
  <div>
    <div class="page-title-area">
      <banner :guide="guide" />>
      <plans @plan-selected="selectPlan" :guide="guide" />
    </div>

    <!-- End Page Title -->
    <div class="container  ptb-80 pt-0">
      <!-- <div class="container"> -->
      <div class="related-users">
        <div class="related-header">
          <h1>Storytellers</h1>
          <span @click="$router.push('/guides')">See all</span>
        </div>
      </div>
      <!-- </div> -->
      <div class="row">
        <div
          class="col-lg-3 col-md-4 col-sm-6"
          v-for="aGuide in allGuides.slice(0, 4)"
          :key="aGuide.id"
        >
          <guide-card :aGuide="aGuide"></guide-card>
        </div>
      </div>
    </div>
    <video-modal></video-modal>
    <booking
      :session="plan"
      :guide="guide"
      ref="bookingComponent"
      @showLoginModal="showLoginModal"
      :bookingForm="bookingForm"
    />
    <!-- <SidebarGuide></SidebarGuide> -->
    <!-- <div v-if="showGuideHelp">
      <help-chat :guide="guide" :ip="ip" />
    </div> -->
    <Form :isBooking="true" @BookingForm="BookingForm" />
  </div>
</template>

<script>
import HelpChat from "@/components/helpChat";
import Banner from "@/components/other-pages/guide/Banner";
import Plans from "@/components/other-pages/guide/Posts";
import Booking from "@/components/other-pages/guide/Booking";
import GuideCard from "@/components/other-pages/guides/GuideCard";
import VideoModal from "@/components/other-pages/guide/VideoModal";
import Form from "@/components/layout/Form";

export default {
  name: "CrewMemberProfile",
  components: {
    Banner,
    // HelpChat,
    Pricing,
    Booking,
    GuideCard,
    VideoModal,
    Form
  },
  data() {
    return {
      guideId: this.$route.params.guideId,
      guide: {},
      plan: {},
      allGuides: [],
      showGuideHelp: true,
      ip: "",
      bookingForm: null
    };
  },
  watch: {
    guideId(newValue, oldValue) {
      this.getGuides();
    }
  },
  mounted() {
    this.getGuides();
  },
  methods: {
    selectPlan(p) {
      this.plan = p;
    },
    getGuides() {
      this.guide = {};
      this.$store
        .dispatch("listings/getGuideByProfileName", this.$route.params.guideId)
        .then(res => {
          this.guide = res;
        })
        .catch(e => {
          console.log(e);
        });
      this.$store.dispatch("listings/getListGuides").then(res => {
        this.allGuides = res;
      });
    },
    showLoginModal() {
      //console.log("inside");
      this.$bvModal.show("loginModal");
    },
    BookingForm(form) {
      console.log("form => ", form);
      this.bookingForm = form;
    }
  }
};
</script>
<style scoped>
.container {
  position: relative;
}
.page-title-area {
  background: none;
  padding-top: 72px;
  padding-bottom: 20px;
}

.btn {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0.05em;
  padding: 9px 18px 0px 16px;
  width: 120px;
}
.related-users {
  margin-top: 30px;
}
.related-header {
  display: flex;
}
.related-header h1 {
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  color: #52595e;
  margin-right: 22px;
}
.related-header span {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #557efb;
  cursor: pointer;
}
/* .video-btn:hover {
  color: #fff;
  background: #557efb;
  box-shadow: 0 13px 27px 0 rgba(85, 126, 251, 0.75);
} */
.video-btn::after,
.video-btn::before {
  content: none;
  /* background: #557efb; */
}
/* .btn::before {
  border-radius: 0 32px 32px 0;
}
.btn::after {
  border-radius: 32px 0 0 32px;
} */
</style>
<style>
#loginModal___BV_modal_outer_ {
  z-index: 10001 !important;
}
</style>
